import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { SplashScreen } from "@/components/site/SplashScreen";
import { ScrollToTop } from "@/components/site/ScrollToTop";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ResearchPage from "@/pages/ResearchPage";
import TeachingPage from "@/pages/TeachingPage";
import CVPage from "@/pages/CVPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminContentEditor from "@/pages/admin/AdminContentEditor";
import AdminListManager from "@/pages/admin/AdminListManager";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminSettings from "@/pages/admin/AdminSettings";
import RequireAuth from "@/pages/admin/RequireAuth";

function PublicLayout({ children }) {
    useLenis();
    return (
        <div className="min-h-screen flex flex-col lg:pl-[300px]">
            <Nav />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
}

function App() {
    return (
        <HelmetProvider>
            <AuthProvider>
                <BrowserRouter>
                    <SplashScreen />
                    <ScrollToTop />
                    <Toaster position="top-right" richColors closeButton />
                    <Routes>
                        {/* Public site */}
                        <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
                        <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
                        <Route path="/research" element={<PublicLayout><ResearchPage /></PublicLayout>} />
                        <Route path="/teaching" element={<PublicLayout><TeachingPage /></PublicLayout>} />
                        <Route path="/cv" element={<PublicLayout><CVPage /></PublicLayout>} />
                        <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />

                        {/* Admin */}
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
                            <Route index element={<AdminDashboard />} />
                            <Route path="content/:section" element={<AdminContentEditor />} />
                            <Route path="publications" element={<AdminListManager kind="publications" />} />
                            <Route path="projects" element={<AdminListManager kind="projects" />} />
                            <Route path="awards" element={<AdminListManager kind="awards" />} />
                            <Route path="courses" element={<AdminListManager kind="courses" />} />
                            <Route path="conferences" element={<AdminListManager kind="conferences" />} />
                            <Route path="media" element={<AdminMedia />} />
                            <Route path="messages" element={<AdminMessages />} />
                            <Route path="settings" element={<AdminSettings />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </HelmetProvider>
    );
}

export default App;
